var DayCollectionStatistic = function () { return import('~/pages/report-manage/day-collection-statistic.vue'); };
var BehaviourControl = function () { return import('~/pages/report-manage/behaviour-control.vue'); };
var ClientBackMoney = function () { return import('~/pages/report-manage/client-back-money.vue'); };
var CollectorBackMoney = function () { return import('~/pages/report-manage/collector-back-money.vue'); };
var FollowRecord = function () { return import('~/pages/report-manage/follow-record.vue'); };
var RepayList = function () { return import('~/pages/report-manage/repay-list.vue'); };
var RepayListSz = function () { return import('~/pages/report-manage/repay-list-sz.vue'); };
var RepayListMs = function () { return import('~/pages/report-manage/repay-list-ms.vue'); };
var RepayListTq = function () { return import('~/pages/report-manage/repay-list-tq.vue'); };
var CommissionList = function () { return import('~/pages/report-manage/commission-list.vue'); };
var GradesReport = function () { return import('~/pages/report-manage/grades-report.vue'); };
var CaseQueryLog = function () { return import('~/pages/report-manage/case-query-log.vue'); };
export default [
    {
        path: '/report-manage/day-collection-statistic',
        name: 'day-collection-statistic',
        component: DayCollectionStatistic
    },
    {
        path: '/report-manage/behaviour-control',
        name: 'behaviour-control',
        component: BehaviourControl
    },
    {
        path: '/report-manage/client-back-money',
        name: 'client-back-money',
        component: ClientBackMoney
    },
    {
        path: '/report-manage/collector-back-money',
        name: 'collector-back-money',
        component: CollectorBackMoney
    },
    {
        path: '/report-manage/follow-record',
        name: 'follow-record',
        component: FollowRecord
    },
    {
        path: '/report-manage/repay-list',
        name: 'repay-list',
        component: RepayList
    },
    {
        path: '/report-manage/repay-list-sz',
        name: 'repay-list-sz',
        component: RepayListSz
    },
    {
        path: '/report-manage/repay-list-ms',
        name: 'repay-list-ms',
        component: RepayListMs
    },
    {
        path: '/report-manage/repay-list-tq',
        name: 'repay-list-tq',
        component: RepayListTq
    },
    {
        path: '/report-manage/commission-list',
        name: 'commission-list',
        component: CommissionList
    },
    {
        path: '/report-manage/grades-report',
        name: 'grades-report',
        component: GradesReport
    },
    {
        path: '/report-manage/case-query-log',
        name: 'case-query-log',
        component: CaseQueryLog
    }
];
